import React from "react";

const ContractDetailPage: React.FC = () => {
  return (
    <div className="container bg-white rounded-top pb-5">

      {/* Breadcrumb Title */}
      <div className="py-3">
        <small className="text-muted">Contract Detail</small>
      </div>

      {/* Contract Name */}
      <div className="mb-3">
        <h5 className="fw-bold m-0">Pemasangan POSM Bebelac</h5>
      </div>

      {/* Banner Image */}
      <div className="mb-3">
        <img
          src="/dummy-banner.jpg"
          alt="contract banner"
          className="img-fluid rounded"
        />
      </div>

      {/* Client Name */}
      <div className="mt-4">
        <small className="text-muted d-block">Client Name</small>
        <h6 className="fw-bold mb-0">Danone Indonesia</h6>
      </div>

      {/* Client Address */}
      <div className="mt-3 mb-4">
        <small className="text-muted d-block">Client Address</small>
        <span className="fw-bold">
          Jalan Kesejahteraan Raya No. 50, Jakarta
        </span>
      </div>

      {/* Contract Info Box */}
      <div className="border rounded p-3 mb-4">
        <div className="row text-center">

          <div className="col-4">
            <small className="text-muted d-block">Nilai Kontrak</small>
            <strong>Rp 2.000.000</strong>
          </div>

          <div className="col-4">
            <small className="text-muted d-block">Mulai</small>
            <strong>01 Okt 2025</strong>
          </div>

          <div className="col-4">
            <small className="text-muted d-block">Expired</small>
            <strong>01 Okt 2025</strong>
          </div>

        </div>
      </div>

      <hr />

      <div className="mt-4">
        <h6 className="fw-bold mb-3">Timeline Contract</h6>

        <div className="timeline">

          {[
            { title: "Installer Sedang Mengirim POSM", date: "26 Sep 2025 13:00:01" },
            { title: "Installer sudah sampai toko", date: "26 Sep 2025 13:00:01" },
            { title: "POSM sudah dipasang", date: "26 Sep 2025 13:00:01" },
            { title: "Pembayaran Fee Pemasangan", date: "menunggu..." },
          ].map((item, idx, arr) => (
            <div className="timeline-row" key={idx}>

              <div className="timeline-icon-wrapper">
                <div className="timeline-dot"></div>

                {/* Garis hanya muncul kalau bukan item terakhir */}
                {idx !== arr.length - 1 && <div className="timeline-line"></div>}
              </div>

              <div className="timeline-info">
                <strong>{item.title}</strong>
                <div className="text-muted small">{item.date}</div>
              </div>

            </div>
          ))}

        </div>
      </div>
    </div>
  );
};

export default ContractDetailPage;